<template>
  <!-- 床位管理 -->
  <div>
    <el-row>
      <!-- 左侧树状结构 -->
      <el-col :span="5">
        <basic-container>
          服务网点：<el-select v-model="nursinghomeId" placeholder="请选择服务网点">
            <el-option
              v-for="(item, index) in nursinghomeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <div :style="'height:' + (bodyHeight - 200) + 'px; overflow: scroll; margin-top: 10px;'">
            <el-tree
              ref="buildingTree"
              node-key="id"
              :data="treeData"
              :props="treeProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              lazy
              :load="treeLazyLoad"
              @node-click="treeNodeClick"
            >
              <span slot-scope="{ node }" class="custom-tree-node">
                <template v-if="node.data.nextNum">
                  {{ node.data.name + '[' + (node.data.nextNum || 0) + ']' }}
                </template>
                <template v-else>
                  {{ node.data.name }}
                </template>
              </span>
            </el-tree>
          </div>
        </basic-container>
      </el-col>
      <!-- 右侧crud -->
      <el-col :span="19">
        <basic-container>
          <!-- 加这一层div是为了保证区域高度是固定的。因为如果只给 avue-crud 设置高度，会因为是否有数据导致区域高度发生变化 -->
          <div :style="'height:' + (bodyHeight - 158) + 'px;'">
            <avue-crud
              v-if="selectedTreeData"
              ref="crud"
              :option="tableOption"
              :table-loading="loading"
              :data="tableData"
              :page.sync="tablePage"
              @search-change="searchChange"
              @search-reset="searchReset"
              @refresh-change="loadData"
              @cell-click="cellClick"
              :cell-style="cellStyle"
              @on-load="loadData"
            >
              <template slot="menuLeft">
                <el-button
                  v-if="permissionList[nextNodeLevel].addBtn"
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="openFromDialog('add')"
                >
                  {{ addText }}
                </el-button>
              </template>
              <template slot-scope="{ row }" slot="menu">
                <el-button
                  v-if="
                    (nextNodeLevel == 'room' || nextNodeLevel == 'bed') &&
                    permissionList[nextNodeLevel].editBtn
                  "
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  @click="openFromDialog('edit', row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="permissionList[nextNodeLevel].delBtn"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click="doDel(row)"
                >
                  删除
                </el-button>
              </template>
            </avue-crud>
          </div>
        </basic-container>
      </el-col>
    </el-row>
    <!-- 表单弹框 -->
    <el-dialog
      :title="formTitle"
      :width="formType == 'edit' && nextNodeLevel == 'room' ? '50%' : '80%'"
      :visible.sync="isFormDialogShow"
      :before-close="beforeCloseFormDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Form
        v-if="isFormDialogShow"
        :type="formType"
        :level="nextNodeLevel"
        :rowData="rowData"
        :nursinghomeId="nursinghomeId"
        @update="updateTableDataSuccess('form')"
        @close="beforeCloseFormDialog"
      ></Form>
    </el-dialog>

    <hr-dialog
      title="查看老人"
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <peopleForm
          model="view"
          :isBed="true"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
        ></peopleForm>
      </template>
    </hr-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from './form';
import peopleForm from '../oldPeople/peopleForm';
import { removeStore } from '@/util/store';
import { getNursinghomeList } from '../api/public.js';
import {
  getBuildingTreeApi,
  getBuildingPageListApi,
  getFloorPageListApi,
  getRoomPageListApi,
  getBedPageListApi,
  removeBuildingApi,
  removeFloorApi,
  removeRoomApi,
  removeBedApi,
} from '../api/bedManage';

export default {
  components: {
    Form,
    peopleForm
  },
  data() {
    return {
      nursingFormVisible: false, // 查看老人弹窗显隐
      formRow: null, // 当前点击的行数据
      nursinghomeList: [], // 养老院列表
      nursinghomeId: '', // 养老院id
      treeData: [], // 树的数据
      // 默认的根节点
      defaultRootData: [
        {
          id: 0,
          name: '楼房管理',
          nextType: 1,
          children: [],
        },
      ],
      // 树的节点属性
      treeProps: {
        label: 'name',
        isLeaf: (data) => {
          return data.nextType == this.leafType;
        },
      },
      leafType: -1, // 叶子节点的类型
      selectedTreeData: null, // 选中的树节点对应的数据
      selectedParentData: null, // 选中的树节点的父元素对应的数据
      nextNodeLevel: '', // 选中的树节点的下一层级的标识符
      // 层级的前后端映射
      levelMap: {
        1: 'building',
        2: 'floor',
        3: 'room',
        4: 'bed',
      },
      // 层级对应的信息
      levelInfo: {
        building: {
          label: '楼栋',
          parentKey: 'nursinghomeId',
          pageListFn: getBuildingPageListApi,
          delFn: removeBuildingApi,
        },
        floor: {
          label: '楼层',
          parentKey: 'buildingId',
          pageListFn: getFloorPageListApi,
          delFn: removeFloorApi,
        },
        room: {
          label: '房间',
          parentKey: 'floorId',
          pageListFn: getRoomPageListApi,
          delFn: removeRoomApi,
        },
        bed: {
          label: '床位',
          parentKey: 'roomId',
          pageListFn: getBedPageListApi,
          delFn: removeBedApi,
        },
      },
      formType: '', // 表单弹框的类型
      formTitle: '', // 表单弹框显示的标题
      isFormDialogShow: false, // 表单弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      addText: '', // 新增按钮的显示的文本
      loading: false,
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      defaultTableOption: {
        height: this.bodyHeight - 280,
        calcHeight: 0,
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 18,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 160,
        column: [],
      },
      // 每种类型的显示项配置
      columns: {
        building: [
        {
            label: '楼栋编号',
            prop: 'code',
          },
          {
            label: '楼栋名称',
            prop: 'name',
          },
          {
            label: '楼层数量',
            prop: 'floorNum',
          },
          {
            label: '房间数',
            prop: 'roomNum',
          },
          {
            label: '床位总数量',
            prop: 'bedCount',
          },
          {
            label: '空闲床位数',
            prop: 'freeBedCount',
          },
          {
            label: '使用床位数',
            prop: 'usedBedCount',
          },
          {
            label: '预约床位数',
            prop: 'bookBedCount',
          },
        ],
        floor: [
          {
            label: '楼层名称',
            prop: 'name',
          },
          {
            label: '床位总数量',
            prop: 'bedCount',
          },
          {
            label: '空闲床位数',
            prop: 'freeBedCount',
          },
          {
            label: '使用床位数',
            prop: 'usedBedCount',
          },
          {
            label: '预约床位数',
            prop: 'bookBedCount',
          },
          {
            label: '所属楼栋',
            prop: 'buildingName',
          },
        ],
        room: [
          {
            label: '房间名称',
            prop: 'name',
          },
          {
            label: '房间朝向',
            prop: 'towardType',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursing_toward_type',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '床位总数量',
            prop: 'bedCount',
          },
          {
            label: '空闲床位数',
            prop: 'freeBedCount',
          },
          {
            label: '使用床位数',
            prop: 'usedBedCount',
          },
          {
            label: '预约床位数',
            prop: 'bookBedCount',
          },
          {
            label: '所属楼栋',
            prop: 'buildingName',
          },
          {
            label: '所属楼层',
            prop: 'floorName',
          },
        ],
        bed: [
          {
            label: '床位名称',
            prop: 'name',
          },
          {
            label: '床位号',
            prop: 'code',
          },
          {
            label: '床位类型',
            prop: 'bedTypeName',
          },
          {
            label: '状态',
            prop: 'bedStatus',
            dicUrl: 'api/blade-system/dict/dictionary?code=nursing_bed_status',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '所住老人',
            prop: 'liveUserName',
          },
          {
            label: '所属楼栋',
            prop: 'buildingName',
          },
          {
            label: '所属楼层',
            prop: 'floorName',
          },
          {
            label: '所属房间',
            prop: 'roomName',
          },
          {
            label: '护理类型',
            prop: 'nursingType',
            dicUrl: 'api/blade-system/dict/dictionary?code=nursing_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
        ],
      },
    };
  },

  computed: {
    // 各层级的按钮权限
    ...mapGetters(['permission']),
    permissionList() {
      return {
        building: {
          addBtn: this.vaildData(this.permission.building_add, false),
          editBtn: this.vaildData(this.permission.building_edit, false),
          delBtn: this.vaildData(this.permission.building_delete, false),
        },
        floor: {
          addBtn: this.vaildData(this.permission.floor_add, false),
          editBtn: this.vaildData(this.permission.floor_edit, false),
          delBtn: this.vaildData(this.permission.floor_delete, false),
        },
        room: {
          addBtn: this.vaildData(this.permission.room_add, false),
          editBtn: this.vaildData(this.permission.room_edit, false),
          delBtn: this.vaildData(this.permission.room_delete, false),
        },
        bed: {
          addBtn: this.vaildData(this.permission.bed_add, false),
          editBtn: this.vaildData(this.permission.bed_edit, false),
          delBtn: this.vaildData(this.permission.bed_delete, false),
        },
      };
    },
    // 数据的表格展示配置项
    tableOption() {
      this.defaultTableOption.column = this.columns[this.nextNodeLevel];
      return this.defaultTableOption;
    },
  },
  watch: {
    nursinghomeId(val1, val2) {
      let item = this.nursinghomeList.find((item) => item.id == val1);
      this.defaultRootData[0].id = this.nursinghomeId;
      this.defaultRootData[0].name = item ? item.name : '楼房管理';
      this.defaultRootData[0].children = [];
      this.treeData = [...this.defaultRootData]; // 这里不能直接赋值，否则左侧树无法重置成根节点的状态
      this.tableData = [];
      this.rootDataUpdate();
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.nursinghomeId = this.nursinghomeList[0].id;
      }
    });
  },
  methods: {
    /* 根节点数据变化 */
    rootDataUpdate() {
      // 高亮显示根节点并主动加载右侧的数据 tips：这里一定要在$nextTick里执行，直接写会没效果
      this.$nextTick(() => {
        this.$refs.buildingTree.setCurrentKey(this.treeData[0].id);
        this.treeNodeClick(this.treeData[0]);
      });
    },
    /* 懒加载树 */
    treeLazyLoad(node, resolve) {
      if (!this.nursinghomeId) return;
      if (node.level == 0) {
        this.treeData = this.defaultRootData;
        resolve(this.treeData);
        this.rootDataUpdate();
        return;
      }
      // 无下一级节点
      if (node.data.nextType == this.leafType) {
        resolve({});
        return;
      }
      getBuildingTreeApi({
        parentId: node.data.id,
        type: node.data.nextType,
      }).then(({ data }) => {
        resolve(data);
      });
    },
    /* 选中树的节点 */
    treeNodeClick(data, node) {
      // 如果是点击的叶子节点，则选中项自动切换成父级节点
      if (data.nextType == this.leafType) {
        node = node.parent;
        data = node.data;
      }
      this.tableData = [];
      this.selectedTreeData = data;
      // tips: 此处不要直接保存node，因为tree组件有bug，即使没有点击节点，但是 node.parent 会莫名其妙的就变成null了，该提交记录的上一版就是保存的node--有bug
      if (node && node.parent) {
        this.selectedParentData = node.parent.data;
      } else {
        this.selectedParentData = {};
      }
      // 右侧需要根据不同层级展示不同的内容
      this.nextNodeLevel = this.levelMap[this.selectedTreeData.nextType];
      this.addText = '新增' + this.levelInfo[this.nextNodeLevel].label;
      this.loadData();
    },
    loadData(page) {
      if (!this.selectedTreeData) return;
      page = page || this.tablePage;
      this.loading = true;
      let fn = this.levelInfo[this.nextNodeLevel].pageListFn;
      let idKey = this.levelInfo[this.nextNodeLevel].parentKey;
      fn({
        [idKey]: this.selectedTreeData.id,
        current: page.currentPage,
        size: page.pageSize,
      }).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 打开表单弹框 */
    openFromDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        edit: '编辑',
      };
      this.formTitle = titles[type] + this.levelInfo[this.nextNodeLevel].label;
      this.formType = type;
      this.rowData = rowData;
      if (this.formType == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
        // 新建时需要将当前的父级信息传递给子组件
        if (this.formType == 'add') {
          this.rowData.nursinghomeId = this.nursinghomeId;
          let idKey = this.levelInfo[this.nextNodeLevel].parentKey;
          this.rowData[idKey] = this.selectedTreeData.id;
        }
      }
      this.isFormDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseFormDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.isFormDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.isFormDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess(source) {
      this.loadData();
      if (source == 'form') {
        this.isFormDialogShow = false;
      }
      // 更新左侧的树
      if (this.selectedTreeData.nextType != 1) {
        // 更新父级（父级展示了子级的总数，这个需要刷新。并且刷新数据后当前层级会被折叠，再次展开时会触发调用获取数据的接口，所以此时并不需要更新当前层级的数据）
        getBuildingTreeApi({
          parentId: this.selectedParentData.id,
          type: this.selectedParentData.nextType,
        }).then(({ data }) => {
          this.$refs.buildingTree.updateKeyChildren(this.selectedParentData.id, data);
          this.$nextTick(() => {
            this.$refs.buildingTree.setCurrentKey(this.selectedTreeData.id);
          });
        });
      } else {
        // 更新当前层级
        getBuildingTreeApi({
          parentId: this.selectedTreeData.id,
          type: this.selectedTreeData.nextType,
        }).then(({ data }) => {
          this.$refs.buildingTree.updateKeyChildren(this.selectedTreeData.id, data);
          this.$nextTick(() => {
            this.$refs.buildingTree.setCurrentKey(this.selectedTreeData.id);
          });
        });
      }
    },
    /* 删除指定行数据 */
    doDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let fn = this.levelInfo[this.nextNodeLevel].delFn;
          return fn({
            ids: row.id,
          });
        })
        .then(() => {
          this.updateTableDataSuccess('del');
          this.$message.success('操作成功!');
        });
    },

    cellClick(row, column) {
      if (column.label === '所住老人') {
        console.log(row);
        if (row.liveUserName) {
          row.id = row.liveUserId
          this.formRow = row
          this.nursingFormVisible = true
        } else {
          this.$message.warning('该房间暂无入住信息!');
        }
      }
    },
    cellStyle({column}) {
      if (column.label === '所住老人') {
        return {
          color: '#409eff',
          cursor: 'pointer',
        };
      }
    },

    closeAddOldManDialog(){
      removeStore({
        name:'elderId'
      });
    },

    recordCancle() {
      removeStore({
        name:'elderId'
      });
      this.nursingFormVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
